import { render, staticRenderFns } from "./SRightHeaderComponent.vue?vue&type=template&id=676a0cb8"
import script from "./SRightHeaderComponent.vue?vue&type=script&lang=js"
export * from "./SRightHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports